import React from "react";

// Wordmark image logo (orange-on-transparent) — reads correctly on the
// app's dark-green (bg-primary) headers/shells used across Admin, POS,
// Driver, and Customer.
export function BrandLogo({ className = "h-7", testId = "brand-logo" }) {
  return (
    <img
      src="/branding/long_logo.png"
      alt="The Virsa Tiffin"
      className={`${className} w-auto select-none`}
      data-testid={testId}
      draggable={false}
    />
  );
}
